import { FC } from 'react';

import { ModuleDataTable } from 'dashboard/modules/DataTable';
import DataTable from 'dashboard/modules/DataTable/DataTable';
import { useResolveCaseVariableQueryState } from 'dashboard/redux/api/cases';
import { useSelectResolvedVariable } from 'dashboard/redux/selectors/layouts';

export interface DataTableContextAdapterProps {
  module: ModuleDataTable;
  token: string;
  resolveVariable: typeof useResolveCaseVariableQueryState;
}

const DataTableContextAdapter: FC<DataTableContextAdapterProps> = ({
  resolveVariable,
  token,
  module,
}) => {
  const { data: tableData = [] } = useSelectResolvedVariable(
    token,
    module['variable-token'] || '',
    resolveVariable,
  );

  return <DataTable tableData={tableData} module={module} />;
};

export default DataTableContextAdapter;
